<template>
    <b-overlay :show="loading" rounded="sm" class="h-100">
        <WidgetOverview class="mb-0 h-100" :title="$t('dashboard.tipboxCommission')" :items="items" :disabled="!isTipboxActive">
            <ErrorMessage :value="error" />
            <template #disabled-content>
                <b-button variant="primary" :to="{ path: '/widgeter/tipbox/activation' }">
                    {{ $t('sidebar.activateTipbox') }}
                </b-button>
            </template>
        </WidgetOverview>
    </b-overlay>
</template>

<script>
    import WidgetOverview from '@/components/common/WidgetOverview.vue';
    import ErrorMessage from '@/components/common/ErrorMessage.vue';
    import { addMonths, endOfMonth, endOfYear, startOfMonth, startOfYear } from 'date-fns';

    export default {
        name: 'TipboxCommission',
        components: {
            WidgetOverview,
            ErrorMessage,
        },
        data() {
            return {
                requestAmount: this.$req('tipbox/amountStats'),
            };
        },
        computed: {
            isRoleWidgeter() {
                return this.$store.getters['auth/isRoleWidgeter'];
            },
            dataThisMonth() {
                return this.requestAmount.getData('ThisMonth');
            },
            dataLastMonth() {
                return this.requestAmount.getData('LastMonth');
            },
            dataThisYear() {
                return this.requestAmount.getData('ThisYear');
            },
            loading() {
                return this.requestAmount.getAnyLoading();
            },
            error() {
                return this.requestAmount.getError('ThisMonth') || this.requestAmount.getError('LastMonth') || this.requestAmount.getError('ThisYear');
            },
            isTipboxActive() {
                const tipbox = this.$store.getters['tipbox/getTipboxSettings'];
                return tipbox && tipbox.policies && tipbox.paymentDataCompleted;
            },
            items() {
                return [
                    {
                        title: this.$t('dashboard.donationsThisMonth'),
                        value: this.$format.currency(this.dataThisMonth ?? 1500),
                    },
                    {
                        title: this.$t('dashboard.donationsLastMonth'),
                        value: this.$format.currency(this.dataLastMonth ?? 2550),
                    },
                    {
                        title: this.$t('dashboard.donationsThisYear'),
                        value: this.$format.currency(this.dataThisYear ?? 25535),
                    },
                ];
            },
        },
        methods: {
            fetchData() {
                if (!this.isTipboxActive) return;
                if (!this.isRoleWidgeter) return;

                const DATE_FORMAT = 'yyyy-MM-dd';
                const now = new Date();

                const startOfThisMonth = startOfMonth(now);
                const endOfThisMonth = endOfMonth(now);
                const lastMonth = addMonths(now, -1);
                const startOfLastMonth = startOfMonth(lastMonth);
                const endOfLastMonth = endOfMonth(lastMonth);
                const startOfThisYear = startOfYear(now);
                const endOfThisYear = endOfYear(now);

                this.requestAmount.id('ThisMonth').get({
                    requestParams: {
                        startDate: this.$format.date(startOfThisMonth, DATE_FORMAT),
                        endDate: this.$format.date(endOfThisMonth, DATE_FORMAT),
                    },
                });

                this.requestAmount.id('LastMonth').get({
                    requestParams: {
                        startDate: this.$format.date(startOfLastMonth, DATE_FORMAT),
                        endDate: this.$format.date(endOfLastMonth, DATE_FORMAT),
                    },
                });

                this.requestAmount.id('ThisYear').get({
                    requestParams: {
                        startDate: this.$format.date(startOfThisYear, DATE_FORMAT),
                        endDate: this.$format.date(endOfThisYear, DATE_FORMAT),
                    },
                });
            },
        },
        created() {
            this.fetchData();
        },
    };
</script>
